export enum PatientSelectionAnalyticsEnum {
  CLICK_SEARCH_ANOTHER_OPTION = '[PAC WEB] Agendamento - Clicou em Procurar outra opção',
}
